import React from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import GoogleLogin from 'react-google-login';
import { useAuthContext } from 'context/AuthContext/AuthContext';
import useApiPath from 'hook/useApiPath';

export function LoginForm() {
  const navigate = useNavigate();
  const { loginSuccess } = useAuthContext();
  const apiPath = useApiPath();

  const onSubmit = async (response: any) => {
    const tokenResponse = await axios.post(`${apiPath}users/login/google/`, {
      access_token: response.tokenId,
      code: '',
    });
    const { token } = tokenResponse.data;
    await loginSuccess(token);
    navigate('/parts', { replace: true });
  };

  return (
    <form autoComplete='off'>
      <GoogleLogin
        clientId='143619826815-s46v6el75ngtqcda2st2rt3b4e9i6esp.apps.googleusercontent.com'
        buttonText='Login'
        onSuccess={(response) => {
          onSubmit(response);
        }}
        onFailure={(errors) => {
          console.log({ errors });
        }}
        cookiePolicy='single_host_origin'
      />
    </form>
  );
}
